import {register} from '@shopify/theme-sections'
import $ from 'jquery'
import 'slick-carousel'
import '../../styles/components/carousel.scss'
import '../../styles/sections/section-icon-3-cols.scss'

export default register(`section-icon-3-cols`, {
    onLoad() {
        $(`.slide-wrapper`).slick( {
            autoplay: false,
            mobileFirst: true,
            slidesToShow: 1,
            center: false,
            infinite: true,
            dots: true,
            arrows: false,
            responsive: [
                {
                    breakpoint: 900,
                    settings: `unslick`
                }
            ]
        })
    },

    onUnload() {
    },
})